<div class="pd-5">
    <h3 class="text-muted">Payment History</h3>
</div>
<div class="my-cart-card mt-1" *ngIf = "showOrderSkeletonLoader === true">
  <ngx-skeleton-loader 
  count="5"
  [theme]="{ 'border-radius': '0', 
  height: '110px' }"
  ></ngx-skeleton-loader>
</div>
<div class='table-container' *ngIf="!isSmallScreen">
    <table mat-table [dataSource]="paymentHistory" class="mat-elevation-z1 history-table" *ngIf="paymentHistory?.length > 0; else noPaymentHistory">
    <!-- Delivery Date Column -->
    <ng-container matColumnDef="deliveryDate">
    <th mat-header-cell *matHeaderCellDef class="text-center delivery-date"> Delivery Date </th>
    <td mat-cell *matCellDef="let record" class="text-center"> {{ record.cb_sale_orders_cbh?.date_of_delivered ? record.cb_sale_orders_cbh.date_of_delivered : '-' }} </td>
    </ng-container>

    <!-- Invoice Number Column -->
    <ng-container matColumnDef="invoiceNumber">
    <th mat-header-cell *matHeaderCellDef class="text-center invoice-number"> Invoice Number </th>
    <td mat-cell *matCellDef="let record" class="text-center"> {{ record.invoice_number }} </td>
    </ng-container>

    <!-- Sales Order Number Column -->
    <ng-container matColumnDef="salesOrderNumber">
    <th mat-header-cell *matHeaderCellDef class="text-center sale-order-number"> Sales Order Number </th>
    <td mat-cell *matCellDef="let record" class="text-center">
      <a *ngIf="record.cb_sale_orders_cbh?.uuid; else noData" 
         href="javascript:void(0)" 
         (click)="viewSaleOrder(record.cb_sale_orders_cbh.uuid)">
        {{ record.cb_sale_orders_cbh.sale_order_number }}
      </a>
      <ng-template #noData> - </ng-template>
    </td>
    </ng-container>

    <!-- Order Total Column -->
    <ng-container matColumnDef="orderTotal">
    <th mat-header-cell *matHeaderCellDef class="text-right order-total"> Order Total</th>
    <td mat-cell *matCellDef="let record" class="text-right">
      {{ record.cb_sale_orders_cbh?.total_payable ? (record.cb_sale_orders_cbh.total_payable | currency) : '-' }}
    </td>
    </ng-container>


    <!-- Payment Mode Column -->
    <ng-container matColumnDef="paymentMode">
    <th mat-header-cell *matHeaderCellDef class="text-center payment-mode"> Payment Mode </th>
    <td mat-cell *matCellDef="let record" class="text-center"> {{ record._matchingData.CbOrderPaymentsCbh.payment_mode }} </td>
    </ng-container>

    <!-- Auth Code Column -->
    <ng-container matColumnDef="authCode">
    <th mat-header-cell *matHeaderCellDef class="text-center auth-code"> Auth Code </th>
    <td mat-cell *matCellDef="let record" class="text-center"> {{ (record._matchingData?.CbOrderPaymentsCbh?.payment_mode == "Check") ? record._matchingData?.CbOrderPaymentsCbh?.notes || 'N/A' : record._matchingData?.CbOrderPaymentsCbh?.AuthCode || 'N/A' }} </td>
    </ng-container>

    <!-- Amount Paid Column -->
    <ng-container matColumnDef="amountPaid">
    <th mat-header-cell *matHeaderCellDef class="text-right amount-paid"> Amount Paid </th>
    <td mat-cell *matCellDef="let record" class="text-right">
      {{ record._matchingData.CbOrderPaymentsCbh.payment_mode === 'Added to Balance' ? '-' : (record._matchingData.CbOrderPaymentsCbh.amount | currency) }}
    </td>
    </ng-container>

    <!-- Header and Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>

<!-- Card Layout (Shown for screen width < 500px) -->
<div class="card-container" *ngIf="isSmallScreen">
  <div *ngIf="paymentHistory?.length > 0; else noPaymentHistory">
    <div *ngFor="let record of paymentHistory" class="card">
      <div class="card-row">
        <span class="card-header">Delivery Date</span>
        <span class="card-value">
          {{ record.cb_sale_orders_cbh?.date_of_delivered ? record.cb_sale_orders_cbh.date_of_delivered : '-' }}
        </span>
      </div>
      <div class="card-row">
        <span class="card-header">Invoice Number</span>
        <span class="card-value">{{ record.invoice_number }}</span>
      </div>
      <div class="card-row">
        <span class="card-header">Sales Order Number</span>
        <span class="card-value">
          <a *ngIf="record.cb_sale_orders_cbh?.uuid; else noDatamobile" 
            href="javascript:void(0)" 
            (click)="viewSaleOrder(record.cb_sale_orders_cbh.uuid)">
          {{ record.cb_sale_orders_cbh.sale_order_number }}
        </a>
        <ng-template #noDatamobile> - </ng-template>
        </span>
      </div>
      <div class="card-row">
        <span class="card-header">Order Total</span>
        <span class="card-value">{{ record.cb_sale_orders_cbh?.total_payable ? (record.cb_sale_orders_cbh.total_payable | currency) : '-' }}</span>
      </div>
      <div class="card-row">
        <span class="card-header">Payment Mode</span>
        <span class="card-value">
          {{ record._matchingData.CbOrderPaymentsCbh.payment_mode }}
        </span>
      </div>
      <div class="card-row">
        <span class="card-header">Auth Code</span>
        <span class="card-value">
          {{ (record._matchingData?.CbOrderPaymentsCbh?.payment_mode == "Check") ? record._matchingData?.CbOrderPaymentsCbh?.notes || 'N/A' : record._matchingData?.CbOrderPaymentsCbh?.AuthCode || 'N/A' }}
        </span>
      </div>
      <div class="card-row">
        <span class="card-header">Amount Paid</span>
        <span class="card-value">{{ record._matchingData.CbOrderPaymentsCbh.payment_mode === 'Added to Balance' ? '-' : (record._matchingData.CbOrderPaymentsCbh.amount | currency) }}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #noPaymentHistory>
  <div class="no-data-message text-center" style="padding: 20px; color: #000;">
    <strong>No payment history found</strong>
  </div>
</ng-template>

